<template>
  <PanelPage ref="useAlerts" :loading-overlay="loadingOverlay">
    <v-card>
      <v-card-title>Modify Agency</v-card-title>
      <v-card-title>
        <v-autocomplete
          label="Agency to modify"
          :items="agencys"
          v-model="agToModifyId"
          item-title="visual_name"
          item-value="id"
        />
      </v-card-title>
      <v-divider/>
      <v-form v-show="agToModifyId" @submit.prevent="submit" @reset="reset">
        <v-card-text>
          <v-text-field
            v-model="form.name.value.value"
            :error-messages="form.name.errorMessage.value"
            label="Name of the agency"
          />
          <v-text-field
            v-model="form.address.value.value"
            :error-messages="form.address.errorMessage.value"
            label="Address"
          />
          <v-text-field
            v-model="form.postal_code.value.value"
            :error-messages="form.postal_code.errorMessage.value"
            label="Postal code"
          />
          <v-text-field
            v-model="form.city.value.value"
            :error-messages="form.city.errorMessage.value"
            label="City"
          />
          <v-text-field
            v-model="form.country_alpha2.value.value"
            :error-messages="form.country_alpha2.errorMessage.value"
            label="Country"
            hint="IT, FR"
            @input="form.country_alpha2.value.value = form.country_alpha2.value.value.toUpperCase()"
          />
        </v-card-text>
        <v-card-actions class="justify-end">
          <v-btn type="reset">Reset</v-btn>
          <v-btn type="submit">Submit</v-btn>
        </v-card-actions>
      </v-form>
    </v-card>
  </PanelPage>
</template>

<script setup>
import { onMounted, ref, watch } from "vue";
import { useForm } from 'vee-validate';
import * as yup from 'yup';
import { getFormFromSchema } from "../utils.js";
import PanelPage from "../components/PanelPage.vue";
import { fetchAgencys, modifyPutAgency } from "../remote/agency.js";

// State
const useAlerts = ref(null);
const agencys = ref([]);
const agToModifyId = ref(null); // From the main selector
const loadingOverlay = ref(false);

// Form
// noinspection JSCheckFunctionSignatures
const schema = yup.object({
  name: yup.string().required(),
  address: yup.string().required(),
  postal_code: yup.string().required(),
  city: yup.string().required(),
  country_alpha2: yup.string().required().length(2),
});

const { handleSubmit, handleReset } = useForm({
  validationSchema: schema
});

const form = getFormFromSchema(schema);

function setAgency(agId) {
  const ag = agencys.value.find(el => el['id'] === agId);
  if (ag === undefined) {
    useAlerts.value.errorAlert("No MD with that ID in the system", "Contact an administrator");
    return;
  }
  // Fields = Values
  form.name.value.value = ag['name'];
  form.address.value.value = ag['address'];
  form.postal_code.value.value = ag['postal_code'];
  form.city.value.value = ag['city'];
  form.country_alpha2.value.value = ag['country_alpha2'];
}

watch(agToModifyId, async (newValue) => {
  if (newValue !== null) {
    loadingOverlay.value = true;
    setAgency(newValue);
    loadingOverlay.value = false;
  }
});

async function reset() {
  // noinspection JSValidateTypes
  handleReset();
  setAgency(agToModifyId.value);
}

// noinspection JSValidateTypes
const submit = handleSubmit(async (values) => {
  let payload = {
    name: values['name'],
    address: values['address'],
    postal_code: values['postal_code'],
    city: values['city'],
    country_alpha2: values['country_alpha2'].toUpperCase(),
  };
  console.log(payload);
  loadingOverlay.value = true;
  // Modify MoneyDestination via PUT
  try {
    await modifyPutAgency(useAlerts, payload, agToModifyId.value);
  } catch (e) {
    useAlerts.value.errorAlert('Error during Agency save', e.toString());
  } finally {
    agencys.value = await fetchAgencys();
    loadingOverlay.value = false;
  }
});

onMounted(async () => {
  loadingOverlay.value = true;
  // Retrieve MoneyDestinations
  try {
    agencys.value = await fetchAgencys();
  } catch (e) {
    useAlerts.value.errorAlert('Impossible to load Agencies', e.toString());
  } finally {
    loadingOverlay.value = false;
  }
});


</script>

<style scoped>

</style>
